import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { IJobOrder } from 'app/models';
import { compare, compareDates } from 'app/utils/compare';

@Component({
  selector: 'app-job-order-list-component',
  templateUrl: './job-order-list.component.html',
  styleUrls: ['./job-order-list.component.scss'],
})
export class JobOrderListComponent implements OnInit {
  @Input()
  jobOrders = new Array<IJobOrder>();

  // Dispatch the ID of the JobOrder
  @Output()
  updateClick = new EventEmitter<number>();

  // Dispatch the ID of the JobOrder
  @Output()
  deleteClick = new EventEmitter<number>();

  @Output()
  detailClick = new EventEmitter<number>();

  columnsToDisplay: string[] = [
    'jobName',
    'finalCustomer',
    'deliveryDate',
    'startDate',
    'endDate',
    'ops', // Column related to update and delete icons
  ];

  constructor() {}
  ngOnInit(): void {}

  sortData = (sort: Sort): void => {
    if (this.jobOrders) {
      const data = this.jobOrders.slice();
      if (!sort.active || sort.direction === '') {
        this.jobOrders = data;
        return;
      }

      this.jobOrders = data.sort((a: IJobOrder, b: IJobOrder) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'jobName':
            return compare(a.code, b.code, isAsc);
          case 'finalCustomer':
            return compare(a.finalCustomer, b.finalCustomer, isAsc);
          case 'deliveryDate':
            return compareDates(a.deliveryDate, b.deliveryDate, isAsc);
          case 'startDate':
            return compareDates(a.startDate, b.startDate, isAsc);
          case 'endDate':
            return compareDates(a.endDate, b.endDate, isAsc);
          default:
            return 0;
        }
      });
    }
  };

  onUpdateClick(id: number) {
    this.updateClick.emit(id);
  }

  onDeleteClick(id: number) {
    this.deleteClick.emit(id);
  }

  onDetailClick(id: number) {
    this.detailClick.emit(id);
  }
}
